import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print-advanced";
import { refillPrescription } from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import {
  constructDisplayText,
  getUserDetail,
  formatDate,
} from "../../utils/helper";
const PatientOrderDetail = ({ closePopup, prescriptionId }) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const [singleHerbs, setSingleHerb] = useState([]);
  const [formulaHerbs, setFormulaHerb] = useState([]);
  const orderedPrescription = useSelector(
    (state) => state.prescription.orderedPrescription
  );

  // useEffect(() => {
  //   dispatch(getOrderedPrescription(prescriptionId,()=>{
  //     closePopup();
  //   }));
  // }, [dispatch]);

  const handleReFill = () => {
    const data = {
      action: "requestRefill",
      prescription_id: prescriptionId,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(
      refillPrescription(params, () => {
        closePopup();
      })
    );
  };

  useEffect(() => {
    if (orderedPrescription.length > 0) {
      let singleHerbItems = [];
      let formulaHerbItems = [];
      let formulaTableData = [];

      orderedPrescription[1]?.forEach((x) => {
        if (x.form_display) {
          formulaHerbItems.push(x);
        } else {
          singleHerbItems.push(x);
        }
      });
      var formulaId = 0;
      var modificationId = 0;
      for (let i = 0; i < formulaHerbItems.length; i++) {
        if (
          formulaId !== formulaHerbItems[i].form_id &&
          formulaHerbItems[i].form_id > 0
        ) {
          formulaId = formulaHerbItems[i].form_id;
          formulaTableData.push(
            <>
              <tr
                className="herb-title"
                key={formulaHerbItems[i].herb_id + "title"}
              >
                <td>{formulaHerbItems[i].form_display}</td>
              </tr>
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  <p
                    style={{ marginBottom: 0 }}
                    className={`${
                      formulaHerbItems[i].herb_id == 0
                        ? "sunten-formula-fix"
                        : ""
                    }`}
                  >
                    {formulaHerbItems[i].dosage?.toLocaleString("en-US", {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    })}
                  </p>
                </td>
              </tr>
            </>
          );
        } else {
          if (
            modificationId !== formulaHerbItems[i].mod_id &&
            formulaHerbItems[i].mod_id > 0
          ) {
            modificationId = formulaHerbItems[i].mod_id;
            formulaTableData.push(
              <>
                <tr
                  className="herb-title"
                  key={formulaHerbItems[i].herb_id + "title"}
                >
                  <td>{formulaHerbItems[i].mod_display}</td>
                </tr>
                <tr key={formulaHerbItems[i].herb_id}>
                  <td>
                    {constructDisplayText(
                      formulaHerbItems[i].herb_display,
                      formulaHerbItems[i].HERB_Latin_Name,
                      formulaHerbItems[i].HERB_Chinese_Name,
                      formulaHerbItems[i].INV_ID_Granular
                    )}
                  </td>
                  <td className="text-right">{formulaHerbItems[i].dosage}</td>
                </tr>
              </>
            );
          } else {
            formulaTableData.push(
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">{formulaHerbItems[i].dosage}</td>
              </tr>
            );
          }
        }
      }
      setSingleHerb(singleHerbItems);
      setFormulaHerb(formulaTableData);
    }
  }, [orderedPrescription]);

  return (
    <Modal size="xl" show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            {orderedPrescription && (
              <>
                <div className="inner-section" id="monitor">
                  <div className="row">
                    <div className="col-md-6">
                      <p className="desc">
                        Please review your order, print or use the above tabs to
                        go back and edit the prescription.
                      </p>
                    </div>
                  </div>
                  <div className="item-section" ref={componentRef}>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6 reduce-height">
                            <h5>Practitioner:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.Practitioner_Name}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Patient:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>
                              {getUserDetail()?.firstName}{" "}
                              {getUserDetail()?.lastName}
                            </p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Prescription #</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.Prescription_ID}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Date:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>
                              {formatDate(orderedPrescription[0]?.Created_Date)}
                            </p>
                          </div>
                        </div>

                        {/* <div className="row mt-2">
                          <div className="col-md-6 reduce-height">
                            <h5>Disease:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.DC_Custom}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Pattern:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.DSC_Custom}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Formula(s)</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.FORM_Custom}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Mod(s):</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.MOD_Custom}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Dosage Type:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>
                              {orderedPrescription[0]?.Dosage_Type === 0
                                ? "Raw"
                                : "Granular"}
                            </p>
                          </div>
                        </div> */}
                      </div>
                      <div className="col-md-4 icon">
                        <img src={RxIcon} alt="icon" />
                      </div>
                    </div>
                    <div className="formula-table mt-4">
                      <table className="table table_review">
                        <thead>
                          <tr>
                            <th>FORMULA(S) &amp; HERB(S)</th>
                            <th className="text-right">GRAMS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formulaHerbs.length > 0 && formulaHerbs}
                          {singleHerbs.length > 0 && (
                            <>
                              <tr className="herb-title">
                                <td>Single Herbs</td>
                              </tr>
                              {singleHerbs.map((x) => {
                                return (
                                  <tr key={x.herb_id}>
                                    <td>
                                      {constructDisplayText(
                                        x.herb_display,
                                        x.HERB_Latin_Name,
                                        x.HERB_Chinese_Name,
                                        x.INV_ID_Granular
                                      )}
                                    </td>
                                    <td className="text-right">{x.dosage}</td>
                                  </tr>
                                );
                              })}
                            </>
                          )}

                          <tr>
                            <td className="total-practitioner">Total Price:</td>
                            <td className="text-right">
                              {(
                                orderedPrescription[0]?.Total_Price / 100
                              ).toLocaleString("en-US", {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                                style: "currency",
                                currency: "USD",
                              })}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="serving-section">
                      {orderedPrescription[0]?.Serving_Amount == 0 ||
                      orderedPrescription[0]?.Serving_Per_Day == 0 ||
                      orderedPrescription[0]?.Serving_Days == 0 ? (
                        ""
                      ) : (
                        <>
                          <h3>Serving instructions</h3>
                          {orderedPrescription[0]?.Dosage_Type === 0 ? (
                            <p>
                              {orderedPrescription[0]?.Serving_Per_Day}{" "}
                              packet(s) a day for{" "}
                              {orderedPrescription[0]?.Serving_Days} day(s)
                            </p>
                          ) : (
                            <p>
                              {orderedPrescription[0]?.Serving_Amount}{" "}
                              {orderedPrescription[0]?.Prep_Method == 5
                                ? " capsule(s) "
                                : orderedPrescription[0]?.Prep_Method == 1
                                ? " scoop(s) "
                                : orderedPrescription[0]?.Prep_Method == 6
                                ? " tablet(s) "
                                : "scoop(s) "}
                              {orderedPrescription[0]?.Serving_Per_Day} times a
                              day(s) for {orderedPrescription[0]?.Serving_Days}{" "}
                              day(s)
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="btn-section">
                  <div className="row">
                    <div className={`col-md-9`}>
                      <ReactToPrint
                        copyStyles={true}
                        trigger={() => (
                          <button className="btn-orange">PRINT</button>
                        )}
                        content={() => componentRef.current}
                      />
                    </div>
                    <div className="col-md-3" onClick={() => handleReFill()}>
                      <button className="btn-orange">Request Refill</button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default PatientOrderDetail;
